import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  PageSubTitle,
  Heading,
  Text,
  ButtonIcon,
  Icon
} from 'components/common/Elements/Elements';
import { textToDate } from 'utils/common';

import classes from './Coupons.module.scss';

const Coupons = ({ data }) => {
  const [couponsButton, setCouponsButton] = useState(false);

  const { t } = useTranslation(['activity']);
  const createCoupon = coupon => {
    return [
      {
        icon: 'printList',
        title: `${t('activity:contacts.NAME')}:`,
        value: coupon.name
      },
      {
        title: `${t('activity:filters.CREATED_DATE')}:`,
        value: textToDate(coupon.createdAt)
      },
      {
        title: `${t('activity:billing.DURATION')}:`,
        value: coupon.duration
      },
      {
        title: `${t('activity:billing.APPLY_ON')}:`,
        value: coupon.applyOn
      },
      {
        title: `${t('activity:filters.TYPE')}:`,
        value: coupon.type
      },
      {
        title: `${t('activity:billing.VALUE')}:`,
        value: coupon.value
      }
    ];
  };

  return (
    data && (
      <>
        <div className={classes.headerSection}>
          <PageSubTitle title={t('activity:billing.COUPONS')} />
          {!couponsButton && data.length > 1 && (
            <ButtonIcon
              icon="close"
              rotateIcon={45}
              className={classes.couponsBtn}
              buttonText={`All Coupons (${data.length})`}
              onClick={() => {
                setCouponsButton(true);
              }}
            />
          )}
        </div>
        {data.map(
          (coupon, index) =>
            (couponsButton || (!couponsButton && index < 1)) && (
              <ul className={classes.cell_wrap} key={index}>
                {createCoupon(coupon).map((item, index) => (
                  <li className={classes.cell} key={index}>
                    {!item.icon ? (
                      <>
                        <Heading
                          size={4}
                          weight="r"
                          className={classes.cell_title}
                        >
                          {item.title ? item.title : <>&nbsp;</>}
                        </Heading>
                        <Text
                          type={'p'}
                          size={6}
                          weight="m"
                          className={classes.cell_value}
                        >
                          {item.value ? item.value : <>&nbsp;</>}
                        </Text>
                      </>
                    ) : (
                      <>
                        <div className={classes.iconWrap}>
                          <Icon
                            size="16px"
                            icon="percent"
                            className={classes.icon}
                          />
                        </div>
                        <div>
                          <Heading
                            size={4}
                            weight="r"
                            className={classes.cell_title}
                          >
                            {item.title ? item.title : <>&nbsp;</>}
                          </Heading>
                          <Text
                            type={'p'}
                            size={6}
                            weight="m"
                            className={classes.cell_value}
                          >
                            {item.value ? item.value : <>&nbsp;</>}
                          </Text>
                        </div>
                      </>
                    )}
                  </li>
                ))}
              </ul>
            )
        )}
        {couponsButton && (
          <ButtonIcon
            className={classes.closeCouponsBtn}
            icon={'close'}
            buttonText={`Close Coupons`}
            onClick={() => {
              setCouponsButton(false);
            }}
          />
        )}
      </>
    )
  );
};

Coupons.propTypes = {
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.bool])
};

export default Coupons;
